import type { TabSource } from "@/constants/analytics/Tabs";
import useAppUserTransitionTrackStatus from "@/hooks/useAppUserTransitionTrackStatus";
import useHelpCenter from "@/hooks/useHelpCenter";
import { useAnalytics } from "@/services/Analytics";
import HelpCenterCard from "@/ui/components/profile/HelpCenterCard";
import { Box } from "@/ui/layout";
import { LayoutToken } from "@/ui/theme/tokens";

interface MealSupportHotlineSectionProps {
  tabSource: TabSource;
}

const MealSupportHotlineSection = ({
  tabSource,
}: MealSupportHotlineSectionProps) => {
  const { presentHelpCenter } = useHelpCenter();
  const { track } = useAnalytics();

  const { hasSupportTransitionTrackPatients } =
    useAppUserTransitionTrackStatus();
  const handlePress = () => {
    track("MealSupportHotline Card Pressed", {
      hasSupportTransitionTrackPatients,
      tabSource,
    });
    void presentHelpCenter({ intercomPresenterSource: tabSource });
  };

  if (!hasSupportTransitionTrackPatients) {
    return null;
  }

  return (
    <Box paddingHorizontal={LayoutToken.ContentPaddingHorizontal}>
      <HelpCenterCard contentVariant="mealSupport" onPress={handlePress} />
    </Box>
  );
};

export default MealSupportHotlineSection;
